import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { unlockPremiumAccess } from './firebaseUtils';

function PremiumUnlock({ onUnlock }) {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!code.trim()) return;
    setLoading(true);
    setStatus('');
    const success = await unlockPremiumAccess(code);
    if (success) {
      setStatus('success');
      if (onUnlock) {
        await onUnlock();
      }
      setTimeout(() => navigate('/premium'), 1500);
    } else {
      setStatus('error');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#111',
      color: '#fff',
      paddingTop: '80px',
      paddingBottom: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        maxWidth: '500px',
        width: '100%',
        padding: '0 16px',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '16px' }}>🔑</div>
        <h1 style={{
          fontFamily: 'Bangers, sans-serif',
          fontSize: 'clamp(1.8rem, 6vw, 2.5rem)',
          letterSpacing: '2px',
          color: '#FFD700',
          marginBottom: '8px',
        }}>
          Unlock Premium Access
        </h1>
        <p style={{ color: '#aaa', marginBottom: '32px', fontSize: '1rem' }}>
          Enter the secret code you received after your donation to unlock exclusive match footage.
        </p>

        <div style={{
          backgroundColor: '#1a1a1a',
          borderRadius: '12px',
          padding: '32px 24px',
          marginBottom: '24px',
        }}>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            placeholder="Enter your code..."
            style={{
              width: '100%',
              padding: '14px',
              borderRadius: '8px',
              border: status === 'error' ? '2px solid #ff4444' : '2px solid #444',
              backgroundColor: '#222',
              color: '#fff',
              fontSize: '1.2rem',
              textAlign: 'center',
              letterSpacing: '2px',
              boxSizing: 'border-box',
              marginBottom: '16px',
              outline: 'none',
            }}
          />

          {status === 'error' && (
            <p style={{ color: '#ff4444', marginBottom: '16px', fontSize: '0.95rem' }}>
              That code doesn't seem right. Double-check and try again!
            </p>
          )}

          {status === 'success' && (
            <p style={{ color: '#00ff88', marginBottom: '16px', fontSize: '1rem', fontWeight: 'bold' }}>
              🎉 Welcome to the Founding Members club! Taking you there now...
            </p>
          )}

          <button
            onClick={handleSubmit}
            disabled={loading || status === 'success'}
            style={{
              width: '100%',
              backgroundColor: status === 'success' ? '#00ff88' : '#FFD700',
              color: '#000',
              border: 'none',
              borderRadius: '8px',
              padding: '14px',
              fontSize: '1.1rem',
              fontFamily: 'Bangers, sans-serif',
              letterSpacing: '2px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Checking...' : status === 'success' ? '✅ Unlocked!' : '🔓 Unlock Access'}
          </button>
        </div>

        <p style={{ color: '#666', fontSize: '0.85rem', marginBottom: '16px' }}>
          Don't have a code yet?
        </p>
        <button
          onClick={() => navigate('/fargo')}
          style={{
            backgroundColor: 'transparent',
            color: '#FFD700',
            border: '1px solid #FFD700',
            borderRadius: '8px',
            padding: '12px 24px',
            fontSize: '0.95rem',
            fontFamily: 'Bangers, sans-serif',
            letterSpacing: '1px',
            cursor: 'pointer',
          }}
        >
          🏆 Become a Founding Member
        </button>
      </div>
    </div>
  );
}

export default PremiumUnlock;